import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseKey)

export const upsertUserProfile = async (profileData) => {
  const { data: { user } } = await supabase.auth.getUser();

  if (!user) throw new Error('No user found');

  const { data, error } = await supabase
    .from('users')
    .upsert({
      id: user.id,
      ...profileData
    })
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const getCurrentUserProfile = async () => {
  const { data: { user } } = await supabase.auth.getUser();

  if (!user) return null;

  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', user.id)
    .single();

  if (error) {
    if (error.code === 'PGRST116') {
      return null;
    }
    throw error;
  }
  return data;
};

export const signUp = async (email, password, userData) => {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        full_name: userData.full_name,
        username: userData.username,
        avatar_url: userData.avatar_url
      }
    }
  });

  if (error) throw error;

  if (data.user) {
    try {
      await upsertUserProfile({
        username: userData.username,
        full_name: userData.full_name,
        avatar_url: userData.avatar_url,
        email: email
      });
    } catch (profileError) {
      console.warn('Could not create user profile:', profileError);
    }
  }

  return data;
};

export const signIn = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  });

  if (error) throw error;
  return data;
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};